import api from "@/api";

const initialGroupState = {
  name: "",
  description: "",
  user: null,
  users: [],
};

export default {
  namespaced: true,

  state: {
    group: initialGroupState,
    groups: [],
    error: null,
    filter: {},
  },
  mutations: {
    /**
     * Put elems within groups state
     */
    SET_GROUPS(state, payload) {
      state.groups = payload;
    },
    /**
     * Set individual group in state
     */
    SET_GROUP(state, payload) {
      state.group = payload;
    },
    ADD_GROUP(state, group) {
      state.groups.push(group);
    },
    SET_ERROR(state, err) {
      state.error = err;
    },
  },
  actions: {
    /**
     * Get all groups
     */
    async list({ commit }) {
      let resp;

      try {
        // TODO: Do we want to get all groups here, or is there an endpoint for a specific user?
        resp = await api().get("/currentuser/usergroups/flat");
        const results = resp.data.data.usergroup;
        commit("SET_GROUPS", results);
        return Promise.resolve(results);
      } catch (err) {
        if (err.response.status === 404 && err.response.data.data.length < 1) {
          commit("SET_GROUPS", []);
          return Promise.resolve([]);
        }
        commit("SET_ERROR", { ...err });
        return Promise.reject(err);
      }
    },

    // Get an individual group
    async read({ commit }, groupId) {
      let resp;
      try {
        resp = await api().get(`/currentuser/usergroup/${groupId}`);
        const results = resp.data.data.usergroup[0];

        commit("SET_GROUP", results);
        return Promise.resolve(results);
      } catch (err) {
        commit("SET_ERROR", { ...err });
        return Promise.reject(err);
      }
    },

    async create({ commit }, params) {
      let resp;
      try {
        resp = await api().post("/usergroup", { usergroup: params });
        commit("ADD_GROUP", resp.data.data.usergroup[0]);
        return Promise.resolve(resp.data.data.usergroup[0]);
      } catch (err) {
        commit("SET_ERROR", { ...err });
        return Promise.reject(err);
      }
    },

    async edit({ commit, dispatch }, params) {
      let resp;
      try {
        resp = await api().post(`/currentuser/usergroup/${params.id}`, {
          usergroup: params,
        });
        dispatch("list");
        return Promise.resolve(resp.data.data.usergroup[0]);
      } catch (err) {
        commit("SET_ERROR", { ...err });
        return Promise.reject(err);
      }
    },

    async delete({ commit }, id) {
      try {
        await api().delete(`/usergroup/${id}`);
        return Promise.resolve();
      } catch (err) {
        commit("SET_ERROR", { ...err });
        return Promise.reject(err);
      }
    },
  },
  getters: {
    filteredUserGroups: (state, _getters, rootState) => {
      return state.groups;
    },
    /**
     * Find a list of groups the user is a member of
     */
    memberGroups: (state, _getters, rootState) => {
      if (!rootState.auth) {
        return [];
      }
      const userId = rootState.auth.currentUser.id;
      if (!state.groups || state.groups.length == 0) {
        return [];
      }
      return state.groups.filter((grp) => {
        if (!grp.user_ids) {
          return false;
        }
        return grp.user_ids.find((mbr) => mbr === userId);
      });
    },
    ownerGroups: (state, _getters, rootState) => {
      if (!rootState.auth) {
        return [];
      }
      const userId = rootState.auth.currentUser.id;
      if (!state.groups || state.groups.length == 0) {
        return [];
      }
      return state.groups.filter((grp) => {
        return grp.user_id === userId;
      });
    },
  },
};
